@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.banners
import com.narbase.letsgo.dto.core.KmmLong

/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017]-[2026] Narbase Technologies
 * All Rights Reserved.
 * Created by khalid-elkhidir
 * On: 2026/04/19.
 */
data class BannerDto(
    val id: KmmLong?,
    val title: String,
    val description: String,
    val backgroundUrl: String?,
    val isActive: Boolean,
)
